import { z } from 'zod';
import { adminAuditFieldsSchema, adminAuditUserSchema } from './IAdminAudit';

export const hutBookRoomSchema = z.object({
    id: z.number(),
    name: z.string(),
    description: z.string().nullable().optional(),
});

export const hutBookEntrySchema = adminAuditFieldsSchema.extend({
    id: z.number().default(-1),
    room: hutBookRoomSchema,
    date_from: z.string().default(''),
    date_to: z.string().default(''),
    entry_for: adminAuditUserSchema,
    can_edit: z.boolean().default(false),
    can_delete: z.boolean().default(false),
});

export const hutBookEntryInputSchema = z.object({
    room_id: z.number().int().positive('Zimmer ist erforderlich'),
    date_from: z.string().min(1, 'Von-Datum ist erforderlich'),
    date_to: z.string().min(1, 'Bis-Datum ist erforderlich'),
    entry_for_id: z.number().int().positive('Person ist erforderlich'),
}).refine((value) => value.date_from <= value.date_to, {
    message: 'Bis-Datum muss am oder nach dem Von-Datum liegen.',
    path: ['date_to'],
});

export type IHutBookEntry = z.infer<typeof hutBookEntrySchema>;
export type IHutBookEntryInput = z.infer<typeof hutBookEntryInputSchema>;
export type IHutBookRoom = z.infer<typeof hutBookRoomSchema>;
